import { useCallback, useState } from 'react'

import {
  POST_COMPENSATION_WITHDRAW_ORDERS_SAVE_DRAFT,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cabinet/compensation/withdraw_orders/save_draft/post'

import {
  POST_COMPENSATION_WITHDRAW_ORDERS_UPDATE_DRAFT,
  convertParams as convertParamsForUpdate,
  convertResult as convertResultForUpdate,
} from 'app/common/api/requests/cabinet/compensation/withdraw_orders/update_draft/post'

import {
  POST_COMPENSATION_WITHDRAW_ORDERS_SEND_DRAFT,
  convertParams as convertParamsForSend,
  convertResult as convertResultForSend,
} from 'app/common/api/requests/cabinet/compensation/withdraw_orders/send_draft/post'

import {
  Withdraw,
  NewDraftParams,
  UpdateDraftParams,
  SendDraftParams,
  DownloadDraftParams,
} from 'app/dataTypes/cafeteria/compensation/withdraw/toParent/draft'

import {
  GET_COMPENSATION_WITHDRAW_ORDERS_DOWNLOAD,
  convertParams as convertParamsForDownload,
} from 'app/common/api/requests/cabinet/compensation/withdraw_orders/download/get'

import { api } from 'app/api'
import { path } from 'ramda'


const defaultWithdraw: Withdraw = {
  withdrawID: null,
}

export function useDraftWithdrawToParentActions() {
  const [withdraw, setWithdraw] = useState<Withdraw>(defaultWithdraw)

  const createDraft = useCallback(async (params: NewDraftParams) => {
    const res = await api.request(POST_COMPENSATION_WITHDRAW_ORDERS_SAVE_DRAFT, {
      error: 'Не удалось отправить данные',
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    })

    if (res) {
      setWithdraw(res)
      return res.withdrawID
    }
    return null
  }, [])

  const updateDraft = useCallback(async (params: UpdateDraftParams) => {
    const res = await api.request(POST_COMPENSATION_WITHDRAW_ORDERS_UPDATE_DRAFT, {
      error: 'Не удалось отправить данные',
      params,
      convertions: {
        convertParams: convertParamsForUpdate,
        convertResult: convertResultForUpdate,
      },
    })

    return !!res
  }, [])

  const sendDraft = useCallback(async (params: SendDraftParams) => {
    const res = await api.request(POST_COMPENSATION_WITHDRAW_ORDERS_SEND_DRAFT, {
      error: (err: Error) => {
        const message = path(['response', 'data', 'message'], err)
        if (message === 'Not enough funds to withdraw') {
          return 'Не удалось отправить данные. Не хватает средств для вывода. Возможно есть заявки на рассмотрении'
        }
        return 'Не удалось отправить данные'
      },
      params,
      convertions: {
        convertParams: convertParamsForSend,
        convertResult: convertResultForSend,
      },
    })

    return !!res
  }, [])

  const downloadDraft = useCallback(async (params: DownloadDraftParams) => {
    const res = await api.download(GET_COMPENSATION_WITHDRAW_ORDERS_DOWNLOAD, {
      error: 'Не удалось скачать файл',
      filename: 'withdraw_order.pdf',
      params,
      convertions: {
        convertParams: convertParamsForDownload,
      },
    })

    return !!res
  }, [])

  return {
    withdraw,
    createDraft,
    updateDraft,
    sendDraft,
    downloadDraft,
  }
}
